export default {"src":"/_next/static/media/wfr-pet-food-co.23eb7f48.svg","height":68,"width":296};